<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'
import router from './../router'
import Lottie from './lottie.vue'
import HuayNumberGrid from '../components/huay/HuayNumberGrid.vue'
import * as animateSantaWalk from '../assets/loading.json'
import moment from 'moment-timezone'

require('vue2-animate/dist/vue2-animate.min.css')

export default {
  name: 'Huay',
  components: {
    HeaderSection: () => import('./Header.vue'),
    FooterSection: () => import('./Footer.vue'),
    Lottie,
    HuayNumberGrid
  },
  data () {
    return {
      isShow: false,
      huays: {},
      showLoading: true,
      buttonLabel: '',
      defaultOptionsSplashScreen: null,
      isDisabled: false,
      QTY: 'loading',
      countQTY: 'loading'
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    selectedCount () {
      return typeof this.countQTY === 'number' ? this.countQTY : '—'
    },
    totalRights () {
      return typeof this.QTY === 'number' ? this.QTY : '—'
    },
    remainingRights () {
      if (typeof this.countQTY !== 'number' || typeof this.QTY !== 'number') return '—'
      return Math.max(this.QTY - this.countQTY, 0)
    },
    progressStyle () {
      if (typeof this.countQTY !== 'number' || typeof this.QTY !== 'number' || this.QTY <= 0) {
        return { width: '0%' }
      }
      return { width: `${Math.min((this.countQTY / this.QTY) * 100, 100)}%` }
    },
    isGridLocked () {
      return !this.isShow || typeof this.countQTY !== 'number' || typeof this.QTY !== 'number' || this.QTY <= 0
    },
    drawStatusLabel () {
      return this.$t(this.isShow ? 'huay_page.status_open' : 'huay_page.status_closed')
    },
    titleCondition () {
      return String(this.$t('huay_page.title2')).replace(/\*\*/g, '')
    },
    rulesDescription () {
      return String(this.$t('huay_page.description')).replace(/\*\*/g, '')
    }
  },
  created () {
    const user = localStorage.getItem('userData')
    if (user) {
      const storedUser = JSON.parse(user)
      this.$store.dispatch('user/setUser', storedUser).then(async () => {
        const huay = (await firebase.database().ref('/huay').once('value')).val()
        const dateHuay = []
        for (const key in huay) {
          dateHuay.push(Number(huay[key]))
        }
        if (dateHuay.includes(Number(moment().tz('Asia/Bangkok').format('D')))) {
          if (Number(moment().tz('Asia/Bangkok').format('H') + moment().tz('Asia/Bangkok').format('mm')) <= 1520) {
            this.calculate()
            this.isShow = true
          } else {
            this.calculate()
          }
        } else {
          this.QTY = 0
          this.countQTY = 0
        }
      }).catch(err => { console.error(err) })
    } else {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/login')
    }
    const animateSplashScreen = animateSantaWalk.default
    this.defaultOptionsSplashScreen = { animationData: animateSplashScreen, autoplay: false, loop: false }
  },
  mounted () {
    this.buttonLabel = this.$t('huay_page.confirm_bet')
    this.animSplashScreen.play()
    setTimeout(() => {
      this.showLoading = false
      this.animSplashScreen.stop()
    }, 3500)
  },
  methods: {
    calculate () {
      firebase.firestore().collection('krungsri')
        .where('date', '>=', moment().tz('Asia/Bangkok').format('YYYY-MM-DD') + ' 00:00:00')
        .where('type', '==', 'ฝาก')
        .where('status', '==', 'ดำเนินการแล้ว')
        .where('userkey', '==', this.user.key)
        .get()
        .then((snapshot) => {
          let deposit = 0
          snapshot.forEach((doc) => {
            deposit += Number(doc.data().qty.toString().replace(',', ''))
          })
          const qty = Math.floor(deposit / 200)
          this.QTY = qty > 10 ? 10 : qty
          if (qty) {
            firebase.firestore().collection('huays')
              .doc(this.user.key + '-' + moment().tz('Asia/Bangkok').format('YYYY-MM-DD'))
              .get()
              .then((doc) => {
                if (doc.exists && doc.data().huays) {
                  for (const key in doc.data().huays) {
                    const number = doc.data().huays[key]
                    this.$set(this.huays, number, true)
                  }
                  this.countQTY = doc.data().huays.length
                } else {
                  this.countQTY = 0
                }
              })
          } else {
            this.countQTY = 0
          }
        })
    },
    selectNumber (number) {
      if (typeof this.countQTY === 'number' && typeof this.QTY === 'number' && this.isShow) {
        if (this.huays[number]) {
          this.$delete(this.huays, number)
          this.countQTY--
        } else if (this.QTY > this.countQTY) {
          this.$set(this.huays, number, true)
          this.countQTY++
        }
      }
    },
    async confirm () {
      if (Object.keys(this.huays).length <= this.QTY && this.QTY > 0) {
        this.buttonLabel = 'loading...'
        this.isDisabled = true
        const huays = []
        for (const number in this.huays) {
          if (this.huays[number]) huays.push(number)
        }
        firebase.firestore().collection('huays')
          .doc(this.user.key + '-' + moment().tz('Asia/Bangkok').format('YYYY-MM-DD'))
          .set({
            huays,
            userkey: this.user.key,
            updatetime: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
            date: moment().tz('Asia/Bangkok').format('YYYY-MM-DD'),
            code: this.user.code
          })
          .then(async () => {
            this.isDisabled = false
            this.buttonLabel = this.$t('huay_page.confirm_bet')
            this.$confirm({
              message: this.$t('huay_page.bet_success'),
              button: {
                yes: 'OK'
              },
              callback: () => null
            })
          })
      } else {
        alert(this.$t('huay_page.check_bet_rights'))
      }
    },
    handleAnimationSplashScreen (animation) {
      this.animSplashScreen = animation
    }
  }
}
</script>

<template>
  <div class="huay-view">
    <div v-if="showLoading" class="loading-screen">
      <div class="loading-screen__halo" aria-hidden="true"></div>
      <Lottie
        :options="defaultOptionsSplashScreen"
        :height="260"
        :width="260"
        @animCreated="handleAnimationSplashScreen"
      />
    </div>

    <div v-else>
      <HeaderSection />
      <div id="main__content">
        <main class="x-main-container">
          <div class="x-main-content">
            <section
              class="x-promotion-index huay-page"
              :style="{ backgroundImage: `url(${require('../assets/images/Shiba-BG.jpg')})` }"
            >
              <div class="huay-page__glow huay-page__glow--left" aria-hidden="true"></div>
              <div class="huay-page__glow huay-page__glow--right" aria-hidden="true"></div>

              <div class="container huay-container">
                <header class="lottery-hero">
                  <div class="lottery-hero__copy">
                    <div class="draw-status" :class="{ 'draw-status--open': isShow }">
                      <span class="draw-status__dot" aria-hidden="true"></span>
                      {{ drawStatusLabel }}
                    </div>
                    <p class="lottery-hero__eyebrow">VR1 LOTTERY CLUB</p>
                    <h1 class="lottery-hero__title">{{ $t('huay_page.title') }}</h1>
                    <p class="lottery-hero__description">{{ titleCondition }}</p>
                  </div>

                  <div class="rights-card" aria-live="polite">
                    <div class="rights-card__topline">
                      <span>{{ $t('huay_page.rights_label') }}</span>
                      <span class="rights-card__remaining">
                        {{ $t('huay_page.remaining_label') }} {{ remainingRights }}
                      </span>
                    </div>
                    <div class="rights-card__score">
                      <strong>{{ selectedCount }}</strong>
                      <span>/ {{ totalRights }}</span>
                    </div>
                    <div class="rights-card__track" aria-hidden="true">
                      <span class="rights-card__progress" :style="progressStyle"></span>
                    </div>
                    <button
                      v-if="isShow"
                      type="button"
                      class="confirm-button confirm-button--desktop"
                      :disabled="isDisabled"
                      @click="confirm"
                    >
                      <span>{{ buttonLabel }}</span>
                      <span class="confirm-button__arrow" aria-hidden="true">→</span>
                    </button>
                  </div>
                </header>

                <section class="lottery-board" aria-labelledby="number-grid-title">
                  <div class="lottery-board__header">
                    <div>
                      <p class="section-kicker">00 — 99</p>
                      <h2 id="number-grid-title" class="lottery-board__title">
                        {{ $t('huay_page.number_heading') }}
                      </h2>
                      <p class="lottery-board__hint">{{ $t('huay_page.number_hint') }}</p>
                    </div>
                    <div class="selection-legend" aria-hidden="true">
                      <span class="selection-legend__swatch"></span>
                      {{ $t('huay_page.selected_label') }}
                    </div>
                  </div>

                  <HuayNumberGrid
                    :selected-numbers="huays"
                    :locked="isGridLocked"
                    @select="selectNumber"
                  />
                </section>

                <aside class="rules-card">
                  <div class="rules-card__icon" aria-hidden="true">i</div>
                  <div class="rules-card__content">
                    <h2 class="rules-card__title">{{ $t('huay_page.rules_title') }}</h2>
                    <p class="rules-card__description">{{ rulesDescription }}</p>
                  </div>
                  <div class="rules-card__stamp" aria-hidden="true">VR1<br>300</div>
                </aside>

                <div v-if="isShow" class="mobile-action">
                  <div class="mobile-action__count">
                    <span>{{ $t('huay_page.selected_label') }}</span>
                    <strong>{{ selectedCount }}/{{ totalRights }}</strong>
                  </div>
                  <button
                    type="button"
                    class="confirm-button confirm-button--mobile"
                    :disabled="isDisabled"
                    @click="confirm"
                  >
                    <span>{{ buttonLabel }}</span>
                    <span class="confirm-button__arrow" aria-hidden="true">→</span>
                  </button>
                </div>
              </div>
            </section>
          </div>
        </main>
        <FooterSection />
      </div>
    </div>
  </div>
</template>

<style scoped>
.huay-view {
  --huay-ink: #101312;
  --huay-paper: #f7ead0;
  --huay-gold: #e8b95f;
  --huay-gold-light: #ffdfa0;
  --huay-copper: #b97022;
  min-height: 100vh;
  background: var(--huay-ink);
  font-family: 'Kanit', sans-serif;
}

.loading-screen {
  position: fixed;
  z-index: 1000;
  inset: 0;
  display: grid;
  place-items: center;
  overflow: hidden;
  background:
    radial-gradient(circle at 50% 42%, rgba(232, 185, 95, 0.15), transparent 28%),
    #0d100f;
}

.loading-screen__halo {
  position: absolute;
  width: 310px;
  height: 310px;
  border: 1px solid rgba(255, 217, 143, 0.14);
  border-radius: 50%;
  box-shadow: 0 0 80px rgba(205, 136, 35, 0.12);
  animation: loading-pulse 1.8s ease-in-out infinite alternate;
}

.huay-page {
  position: relative;
  isolation: isolate;
  min-height: 100vh;
  overflow: hidden;
  padding: 64px 0 88px;
  color: var(--huay-paper);
  background-color: #111412;
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  background-blend-mode: soft-light;
}

.huay-page::before {
  content: '';
  position: absolute;
  z-index: -2;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(10, 12, 11, 0.68) 0%, #101312 42%, #0b0d0c 100%),
    repeating-linear-gradient(90deg, transparent 0, transparent 79px, rgba(255, 255, 255, 0.018) 80px);
}

.huay-page::after {
  content: '';
  position: absolute;
  z-index: -1;
  top: 0;
  right: 5%;
  width: 520px;
  height: 380px;
  opacity: 0.08;
  background-image: radial-gradient(circle, #f6d58d 1.2px, transparent 1.2px);
  background-size: 18px 18px;
  -webkit-mask-image: linear-gradient(135deg, #000, transparent 74%);
  mask-image: linear-gradient(135deg, #000, transparent 74%);
}

.huay-page__glow {
  position: absolute;
  z-index: -1;
  width: 420px;
  height: 420px;
  border-radius: 50%;
  filter: blur(110px);
  pointer-events: none;
}

.huay-page__glow--left {
  top: 220px;
  left: -260px;
  background: rgba(163, 85, 16, 0.34);
}

.huay-page__glow--right {
  right: -300px;
  bottom: 12%;
  background: rgba(211, 151, 53, 0.18);
}

.huay-container {
  position: relative;
  z-index: 1;
  max-width: 1120px;
}

.lottery-hero {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(290px, 0.72fr);
  gap: clamp(28px, 5vw, 76px);
  align-items: end;
  margin-bottom: 38px;
  animation: rise-in 600ms ease both;
}

.draw-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  padding: 7px 12px;
  border: 1px solid rgba(247, 234, 208, 0.16);
  border-radius: 999px;
  color: rgba(247, 234, 208, 0.68);
  background: rgba(255, 255, 255, 0.04);
  font-size: 0.76rem;
  font-weight: 400;
  letter-spacing: 0.04em;
}

.draw-status__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #8c908d;
  box-shadow: 0 0 0 4px rgba(140, 144, 141, 0.12);
}

.draw-status--open {
  border-color: rgba(111, 210, 138, 0.24);
  color: #b9eec5;
  background: rgba(62, 139, 80, 0.1);
}

.draw-status--open .draw-status__dot {
  background: #70dd8d;
  box-shadow: 0 0 0 4px rgba(90, 205, 120, 0.14), 0 0 16px rgba(90, 205, 120, 0.5);
}

.lottery-hero__eyebrow,
.section-kicker {
  margin: 0 0 9px;
  color: var(--huay-gold);
  font-family: 'Droid Sans', sans-serif;
  font-size: 0.73rem;
  font-weight: 700;
  letter-spacing: 0.22em;
}

.lottery-hero__title {
  max-width: 760px;
  margin: 0;
  color: #fff6e5;
  font-size: clamp(2.6rem, 7vw, 5.6rem);
  font-weight: 400;
  line-height: 0.96;
  letter-spacing: -0.045em;
  text-shadow: 0 16px 42px rgba(0, 0, 0, 0.3);
}

.lottery-hero__description {
  max-width: 660px;
  margin: 22px 0 0;
  color: rgba(247, 234, 208, 0.72);
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.75;
}

.rights-card {
  position: relative;
  overflow: hidden;
  padding: 24px;
  border: 1px solid rgba(255, 218, 145, 0.2);
  border-radius: 24px;
  background:
    linear-gradient(145deg, rgba(255, 255, 255, 0.075), rgba(255, 255, 255, 0.015)),
    rgba(16, 19, 18, 0.86);
  box-shadow: 0 26px 70px rgba(0, 0, 0, 0.34);
  backdrop-filter: blur(16px);
}

.rights-card::after {
  content: '99';
  position: absolute;
  top: -36px;
  right: -10px;
  color: rgba(255, 216, 139, 0.045);
  font-family: 'Droid Sans', sans-serif;
  font-size: 9rem;
  font-weight: 700;
  line-height: 1;
  pointer-events: none;
}

.rights-card__topline {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  gap: 14px;
  color: rgba(247, 234, 208, 0.62);
  font-size: 0.8rem;
  font-weight: 300;
}

.rights-card__remaining {
  color: var(--huay-gold-light);
}

.rights-card__score {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: baseline;
  gap: 9px;
  margin: 10px 0 14px;
  font-family: 'Droid Sans', sans-serif;
}

.rights-card__score strong {
  color: #fff6df;
  font-size: 3.35rem;
  line-height: 1;
}

.rights-card__score span {
  color: rgba(247, 234, 208, 0.42);
  font-size: 1.35rem;
}

.rights-card__track {
  position: relative;
  z-index: 1;
  height: 5px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
}

.rights-card__progress {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, var(--huay-copper), var(--huay-gold-light));
  box-shadow: 0 0 16px rgba(232, 185, 95, 0.5);
  transition: width 260ms ease;
}

.confirm-button {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border: 0;
  border-radius: 14px;
  color: #241605;
  background: linear-gradient(135deg, #ffe09d 0%, #e4ad4d 56%, #c27c24 100%);
  box-shadow: 0 10px 25px rgba(184, 111, 23, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.55);
  font-family: 'Kanit', sans-serif;
  font-size: 0.94rem;
  font-weight: 500;
  cursor: pointer;
  transition: transform 180ms ease, box-shadow 180ms ease, filter 180ms ease;
}

.confirm-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(184, 111, 23, 0.36), inset 0 1px 0 rgba(255, 255, 255, 0.62);
  filter: saturate(1.08);
}

.confirm-button:focus-visible {
  outline: 3px solid rgba(255, 222, 157, 0.34);
  outline-offset: 3px;
}

.confirm-button:disabled {
  cursor: wait;
  filter: grayscale(0.45);
  opacity: 0.68;
}

.confirm-button--desktop {
  width: 100%;
  margin-top: 22px;
  padding: 13px 15px 13px 18px;
}

.confirm-button__arrow {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 9px;
  color: #f9d785;
  background: rgba(36, 22, 5, 0.86);
  font-family: sans-serif;
  font-size: 1rem;
}

.lottery-board {
  padding: clamp(22px, 4vw, 42px);
  border: 1px solid rgba(247, 229, 190, 0.13);
  border-radius: 30px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.045), rgba(255, 255, 255, 0.012)),
    rgba(13, 16, 15, 0.9);
  box-shadow: 0 30px 90px rgba(0, 0, 0, 0.28);
  animation: rise-in 600ms 100ms ease both;
}

.lottery-board__header {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 26px;
  padding-bottom: 23px;
  border-bottom: 1px solid rgba(247, 229, 190, 0.1);
}

.lottery-board__title {
  margin: 0;
  color: #fff5e2;
  font-size: clamp(1.35rem, 3vw, 1.75rem);
  font-weight: 400;
  letter-spacing: -0.02em;
}

.lottery-board__hint {
  margin: 6px 0 0;
  color: rgba(247, 234, 208, 0.5);
  font-size: 0.84rem;
  font-weight: 300;
}

.selection-legend {
  display: flex;
  align-items: center;
  flex: none;
  gap: 8px;
  color: rgba(247, 234, 208, 0.5);
  font-size: 0.76rem;
}

.selection-legend__swatch {
  width: 13px;
  height: 13px;
  border: 1px solid #f8d78e;
  border-radius: 4px;
  background: linear-gradient(145deg, #f7d684, #b97022);
  box-shadow: 0 0 12px rgba(232, 185, 95, 0.28);
}

.rules-card {
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 18px;
  align-items: center;
  overflow: hidden;
  margin-top: 22px;
  padding: 24px 28px;
  border: 1px solid rgba(231, 183, 88, 0.18);
  border-radius: 22px;
  background: linear-gradient(100deg, rgba(123, 72, 16, 0.18), rgba(255, 255, 255, 0.025));
  animation: rise-in 600ms 180ms ease both;
}

.rules-card__icon {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border: 1px solid rgba(255, 220, 150, 0.32);
  border-radius: 50%;
  color: #241605;
  background: var(--huay-gold);
  font-family: Georgia, serif;
  font-size: 1rem;
  font-style: italic;
  font-weight: 700;
}

.rules-card__title {
  margin: 0 0 5px;
  color: #ffe5b0;
  font-size: 0.96rem;
  font-weight: 400;
}

.rules-card__description {
  max-width: 830px;
  margin: 0;
  color: rgba(247, 234, 208, 0.63);
  font-size: 0.83rem;
  font-weight: 300;
  line-height: 1.65;
}

.rules-card__stamp {
  display: grid;
  place-items: center;
  width: 72px;
  height: 72px;
  border: 1px dashed rgba(244, 195, 99, 0.34);
  border-radius: 50%;
  color: rgba(244, 195, 99, 0.38);
  font-family: 'Droid Sans', sans-serif;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
  transform: rotate(-8deg);
}

.mobile-action {
  display: none;
}

@keyframes rise-in {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes loading-pulse {
  from { transform: scale(0.94); opacity: 0.45; }
  to { transform: scale(1.04); opacity: 1; }
}

@media (max-width: 991.98px) {
  .huay-page {
    padding-top: 44px;
  }

  .lottery-hero {
    grid-template-columns: minmax(0, 1.15fr) minmax(260px, 0.7fr);
    gap: 28px;
  }
}

@media (max-width: 767.98px) {
  .huay-page {
    padding: 32px 0 38px;
  }

  .huay-container {
    padding-right: 15px;
    padding-left: 15px;
  }

  .lottery-hero {
    grid-template-columns: 1fr;
    gap: 24px;
    margin-bottom: 18px;
  }

  .draw-status {
    margin-bottom: 18px;
  }

  .lottery-hero__title {
    font-size: clamp(2.55rem, 13vw, 4.25rem);
  }

  .lottery-hero__description {
    margin-top: 16px;
    font-size: 0.9rem;
  }

  .rights-card {
    padding: 20px;
    border-radius: 20px;
  }

  .rights-card__score {
    margin-bottom: 12px;
  }

  .rights-card__score strong {
    font-size: 2.8rem;
  }

  .confirm-button--desktop {
    display: none;
  }

  .lottery-board {
    padding: 20px 14px 18px;
    border-radius: 22px;
  }

  .lottery-board__header {
    align-items: start;
    margin-bottom: 18px;
    padding: 0 4px 17px;
  }

  .lottery-board__hint {
    max-width: 220px;
  }

  .selection-legend {
    margin-top: 4px;
  }

  .rules-card {
    grid-template-columns: auto 1fr;
    align-items: start;
    margin-top: 16px;
    padding: 20px;
    border-radius: 18px;
  }

  .rules-card__stamp {
    display: none;
  }

  .mobile-action {
    position: sticky;
    z-index: 10;
    bottom: 12px;
    display: flex;
    align-items: center;
    gap: 14px;
    margin: 18px 0 0;
    padding: 10px 10px 10px 16px;
    border: 1px solid rgba(255, 220, 150, 0.22);
    border-radius: 18px;
    background: rgba(14, 17, 16, 0.9);
    box-shadow: 0 16px 42px rgba(0, 0, 0, 0.46);
    backdrop-filter: blur(18px);
  }

  .mobile-action__count {
    display: flex;
    flex: none;
    flex-direction: column;
    color: rgba(247, 234, 208, 0.5);
    font-size: 0.65rem;
    line-height: 1.2;
  }

  .mobile-action__count strong {
    margin-top: 3px;
    color: #ffe1a2;
    font-family: 'Droid Sans', sans-serif;
    font-size: 1rem;
  }

  .confirm-button--mobile {
    flex: 1;
    min-width: 0;
    padding: 11px 11px 11px 15px;
    font-size: 0.84rem;
  }

  .confirm-button__arrow {
    flex: none;
    width: 27px;
    height: 27px;
  }
}

@media (max-width: 374.98px) {
  .huay-container {
    padding-right: 10px;
    padding-left: 10px;
  }

  .lottery-board {
    padding-right: 10px;
    padding-left: 10px;
  }

  .lottery-board__header {
    gap: 12px;
  }

  .selection-legend {
    font-size: 0.68rem;
  }

  .rules-card {
    gap: 12px;
    padding: 17px;
  }

  .mobile-action {
    gap: 9px;
    padding-left: 12px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .lottery-hero,
  .lottery-board,
  .rules-card,
  .loading-screen__halo {
    animation: none;
  }

  .confirm-button,
  .rights-card__progress {
    transition: none;
  }
}
</style>
